import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MessageService } from 'primeng/api';
import { BehaviorSubject } from 'rxjs';
import { SearchService } from '../../components/search/search-service';
import { ApiService } from '../../services/api.service';
import { AppModule } from '../../utilities/app/app.module';

@Component({
  selector: 'app-videolibrary',
  standalone: true,
  imports: [AppModule, InfiniteScrollModule],
  templateUrl: './videolibrary.component.html',
  styleUrl: './videolibrary.component.scss',
})
export class VideolibraryComponent implements OnInit {
  corpus_name = 'Demo';
  loading = false;
  videos_data = new BehaviorSubject<any>(undefined);

  duration: any = [];
  constructor(
    public router: Router,
    public searchService: SearchService,
    public apiService: ApiService,
    private messageService: MessageService
  ) { }

  // get_values_as_per_page(all_values: any) {

  //   return all_values.slice(
  //     this.first_item_index,
  //     this.first_item_index + this.rows_to_display_per_page
  //   );
  // }

  all_videos: any;
  display_files: any;

  onScroll() {
    let current_index = Object.keys(this.display_files).length;
    if (current_index < Object.keys(this.all_videos).length) {
      let my_key = Object.keys(this.all_videos);
      let keys_to_iterate = Math.min(
        8,
        this.all_videos?.length - current_index
      );
      let some_data: any = {};
      for (let i = current_index; i < current_index + keys_to_iterate; i++) {
        some_data[my_key[i]] = this.all_videos[my_key[i]];
      }
      this.display_files = Object.assign(this.display_files, some_data);
    } else {
      this.display_files = this.all_videos;
    }

    if (
      Object.keys(this.display_files).length ==
      Object.keys(this.all_videos).length
    ) {
      let loader = document.getElementById('current_loader');
      if (loader) {
        loader.getElementsByTagName('span')[0]?.remove();
      }
    }
  }

  ngOnInit() {
    this.apiService.get_all_videos(this.corpus_name).subscribe({
      next: (res: any) => {
        this.videos_data.next(res);
        this.all_videos = res;
        this.display_files = res.slice(0, Math.min(12, res.length));
        this.loading = false;
      },
      error: (err: any) => {
        let summary = 'Error while fetching videos';
        if (err.status == 0) {
          err.status = 503;
          summary = 'Service Unavailable';
        }

        this.messageService.add({
          severity: 'error',
          summary: err.status,
          detail: summary,
        });

        this.loading = false;
      },
    });
  }

  video_duration(event: any) {
    this.duration[event.name] = event.duration;
    console.log(this.duration)
  }

  getTitle(title: any) {
    if (!this.duration[title]) {
      return title;
    } else {
      return title + '\n Duration: ' + this.duration[title];
    }

  }

  async play_video(video_name: any, item: any, corpora_name: any) {
    let url = this.get_url_cloud_front(item.metadata.path);
    this.loading = true;

    this.loading = false;
    let playing_obj = {
      show: true,
      name: video_name,
      url: url,
      corpora_name: corpora_name,
      db_data: item,
    };

    // let my_data = await this.get_blob(url);
    // playing_obj.url = my_data;

    this.router.navigate(['/view_content'], {
      state: { playable_content: playing_obj },
    });
  }

  get_url_cloud_front(url: string) {
    return `${this.apiService.Storage_CDN}/${url}`;
  }

  get_sprite_image(item_data: any) {
    if (item_data.metadata?.sprite?.big_player_compressed) {
      return item_data.metadata.sprite.big_player_compressed
    } else if (item_data.metadata?.sprite?.big_player) {
      return item_data.metadata.sprite.big_player
    } else {
      return ''
    }
  }

}
